import { useSearchParams } from 'next/navigation'

/*
 * Allows access to URL query parameters
 */
export const useQuery = useSearchParams
